/* eslint-disable max-len */
import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import Grid from 'react-bootstrap/lib/Grid';

import './AdvantagesSection.css';

class AdvantagesSection extends PureComponent {
  render() {
    const { t } = this.props;

    const items = [
      {
        title: t('Instant Booking'),
        description: t('Our calendars are in real time. Select your dates and book online.')
      },
      {
        title: t('Best price guaranteed'),
        description: t('You will not find the same bike for the same dates at a better price - guaranteed!')
      },
      {
        title: t('Manage your booking online'),
        description: t('Plans changed? Don\'t worry, you can change dates or cancel your reservation without extra fees.')
      },
      {
        title: t('24/7 Customer Service'),
        description: t('Our multilingual customer service team is on hand to help you enjoy your holidays.')
      }
    ];

    return (
      <div className="section advantages-section">
        <Grid>
          <h2>{t('Why BikesBooking.com?')}</h2>

          <ul className="advantages-list">
            {items.map((item) => (
              <li key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </li>
            ))}
          </ul>
        </Grid>
      </div>
    );
  }
}

export default translate(['translation'])(AdvantagesSection);



// WEBPACK FOOTER //
// ./src/components/HomePage/AdvantagesSection/AdvantagesSection.js